import { useEffect, useState } from "react";

export function useApi(service, params = {}, effects = []) {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const loadData = () => {
    setLoading(true);
    service(params)
      .then((res) => {
        setResponse(res);
        setLoading(false);
        setLoaded(true);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
        setLoaded(true);
      });
  };

  useEffect(() => {
    loadData();
    return () => {};
  }, effects);

  return {
    loading,
    loaded,
    response,
    setResponse,
    error,
    refetch: () => loadData()
  };
}